var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Tooltip } from '@hn-ui/tooltips';
import { isStudentCell } from '../tableConfig';
import { LabelByStudentsFilter, } from '../../../../../constants/filters';
var ScGroupTitleCell = styled.div.withConfig({ displayName: "ScGroupTitleCell", componentId: "sc-1j1hpb0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin-top: 19px;\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  margin-top: 19px;\n"])), function (_a) {
    var theme = _a.theme, $struggled = _a.$struggled;
    return $struggled ? theme.colors.red40 : theme.colors.black10;
});
var GroupTitleCell = function (_a) {
    var original = _a.row.original;
    return (_jsx(ScGroupTitleCell, __assign({ "$struggled": original.name.includes(LabelByStudentsFilter["NeedIntervention" /* NeedIntervention */]) }, { children: original.name }), void 0));
};
var MAX_NAME_LENGTH = 22;
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1mvxsyc" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  max-width: 238px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n  max-width: 238px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
export var StudentNameCell = function (cellProps) {
    if (!isStudentCell(cellProps.row.original))
        return _jsx(GroupTitleCell, __assign({}, cellProps), void 0);
    var original = cellProps.row.original;
    return (_jsx(Tooltip, __assign({ placement: 'top', maxWidth: 310, content: original.name, mountNode: document.body, interactive: original.name.length > MAX_NAME_LENGTH }, { children: _jsx(ScCell, { children: original.name }, void 0) }), void 0));
};
var templateObject_1, templateObject_2;
